module.exports = __webpack_public_path__ + "static/media/83.1f2dae89.png";